import dropdown from "./dropdown";

export default new (class {
    constructor() {
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        let _this = this;
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelector('.select#partners-country .select__input').addEventListener('change', (e) => {
                let country = e.target.value;

                oc.ajax("PartnersRegionList::onAjaxRequest", {
                    data: {
                        country
                    },
                    update: {
                        'partners/dropdown-region': `#dropdown-region`,
                        'partners/partners': `#partners`
                    },
                    complete: function() {
                        dropdown.selectInit();
                        _this.initRegionSelect();
                    },
                });
            })

            this.initRegionSelect();
        });
    }

    initRegionSelect() {
        if(document.querySelector('.select#partners-region .select__input')) {
            document.querySelector('.select#partners-region .select__input').addEventListener('change', (e) => {
                let region = e.target.value;

                oc.ajax("PartnersPartnerList::onAjaxRequest", {
                    data: {
                        region
                    },
                    update: {
                        'partners/partners': `#partners`
                    },
                });
            })
        }
    }
})()
